import { defineComponent as _defineComponent } from 'vue'
import { CancelButton, PrimaryButton } from "@/components/buttons";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationDialog',
  props: {
    title: { type: String, required: false },
    content: { type: String, required: false },
    isLoading: { type: Boolean, required: false }
  },
  emits: ["confirmation-selection"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const __returned__ = { props, emit, get CancelButton() { return CancelButton }, get PrimaryButton() { return PrimaryButton } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})